<template>
  <v-icon
    class=""
    :color="cardType.color"
    :size="size"
    :style="cardType.rotate ? `transform: rotate(${cardType.rotate})` : null"
  >
    {{ cardType.icon }}
  </v-icon>
</template>

<script>
import cardTypes from './cardTypes';
export default {
  props: ['pageType', 'size'],
  computed: {
    cardType() {
      const type = this.pageType >= 0 ? this.pageType : 1;
      return cardTypes[type];
    }
  }
};
</script>

<style></style>
